import generateModel from 'helpers/modelGenerator';

export const UserSummary = generateModel({
  id: 'ID',
  name: 'Name',
});
